"use client";

import { useId } from "react";
import { useNewsletterForm } from "@/app/ui/hooks/useNewsletterForm";

export default function FooterNewsletter() {
  const { email, setEmail, status, message, handleSubmit } = useNewsletterForm();
  const inputId = useId();

  return (
    <div className="text-center">
      <h3 className="font-['Font-Bold'] text-lg text-(--gold) mb-2">Join Our Flock</h3>
      <p className="text-sm text-(--white)/80 mb-4">Be the first to know when we launch</p>
      
      {status === "success" ? (
        <div className="flex items-center justify-center gap-2 text-(--gold)">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
          <span className="font-['Font-Bold']">{message}</span>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 justify-center">
          <label htmlFor={inputId} className="sr-only">Email address</label>
          <input
            id={inputId}
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your@email.com"
            maxLength={100}
            aria-label="Email address for newsletter signup"
            disabled={status === "loading"}
            className="px-4 py-2.5 rounded-lg bg-(--purple) border border-(--brand)/30 text-(--white) placeholder:text-(--white)/50 focus:outline-none focus:ring-2 focus:ring-(--gold) disabled:opacity-60 min-w-[240px]"
          />
          <button
            type="submit"
            disabled={status === "loading"}
            className="px-6 py-2.5 rounded-lg bg-(--gold) text-(--text-on-gold) font-['Font-Bold'] hover:bg-(--brand) hover:text-white transition-colors disabled:opacity-60 disabled:cursor-not-allowed whitespace-nowrap"
          >
            {status === "loading" ? "..." : "Subscribe"}
          </button>
        </form>
      )}
      {status === "error" && (
        <p className="mt-2 text-sm text-(--text-error)">{message}</p>
      )}
    </div>
  );
}
